const origins = {
  methods: {
    createOrigin(e) {
      this.$v.validationGroup["origins.create_form"].$touch();

      console.log("creating new origing");
      console.log(this.$v.validationGroup["origins.create_form"].$invalid);
      console.log(this.$v.validationGroup["origins.create_form"])
      if (this.$v.validationGroup["origins.create_form"].$invalid) {
        return;
      }

      axios
        .post("/origin", this.origins.create_form)
        .then(response => {
          this.$emit("alert", {
            message: response.data.message,
            type: "success"
          });
          this.$set(this.origins, "create_form", {});
          this.$v.validationGroup["origins.create_form"].$reset();
        })
        .catch(error => {
          this.$emit("alert", {
            message: error.response.data.message,
            type: "danger"
          });
        })
        .finally(() => {
          this.fetchInfo();
          this.refreshUser();
        });
    },

    editOrigin(originId) {
      const origin = this.getOriginById(originId);

      console.log('orign',origin);
      if (origin) {
        this.origins.edit_form[originId] = { ...origin };
        console.log('edit forms', this.origins.edit_form);
        this.$refs.origins_table.toggleChildRow(originId - 0);
      }
    },
    onEditOriginSubmit(originId) {
      let vm = this;
      const origin = this.getOriginById(originId);

      this.$v.validationGroup["origins.edit_form"].$touch();

      if (this.$v.validationGroup["origins.edit_form"].$each[originId].$invalid) {
        return;
      }

      if (origin) {
        vm.isLoading = true;
        axios
          .patch("/origin/" + originId, this.origins.edit_form[originId])
          .then(response => {
            vm.$emit("alert", {
              message: response.data.message,
              type: "success"
            });
            this.$refs.origins_table.toggleChildRow(originId - 0);
            this.$v.validationGroup["origins.edit_form"].$reset();
          })
          .catch(error => {
            vm.$emit("alert", {
              message: error.response.data.message,
              type: "danger"
            });
          })
          .finally(() => {
            vm.fetchInfo();
            this.refreshUser();
          });
      }
    },
    onEditOriginReset(e) {},

    async deleteOrigin(id) {
      try{
        const dialog = await this.$dialog.confirm("Are you sure you want to delete the selected origin address?", {
          view: 'warning',
          customClass: 'warning-dialog',
        });
        const response = await axios.delete("/origin/" + id, this.origins.create_form);
        this.$emit("alert", {
          message: response.data.message,
          type: "success",
        });
        dialog.close();
        this.fetchInfo();
        this.refreshUser();
      } catch(e){
        if(e.response){
          this.$emit("alert", {
            message: e.response.data.message,
            type: "danger",
          });
        }
      } finally {
      }
    },
  }
}

export default origins


// WEBPACK FOOTER //
// ./resources/assets/js/views/MyAccount/mixins/Origins.js